import { render, staticRenderFns } from "./onboardSuccess.vue?vue&type=template&id=41390662&scoped=true"
import script from "./onboardSuccess.vue?vue&type=script&lang=js"
export * from "./onboardSuccess.vue?vue&type=script&lang=js"
import style0 from "./onboardSuccess.vue?vue&type=style&index=0&id=41390662&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41390662",
  null
  
)

export default component.exports